'use client';

import dynamic from 'next/dynamic';

const NewsletterPopup = dynamic(() => import('./NewsletterPopup').then((mod) => mod.NewsletterPopup), { ssr: false });

export { NewsletterPopup as NewsletterPopupLazy };
